import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Yard Management Module Service Stores
 * Updated to match backend api-types
 *
 * Note: Yard services don't have a dedicated api-types folder.
 * Related services may be found in the logistics api-types folder (yard-storage).
 */
export const yardStores: ServiceStoreConfig[] = [
  // No yard-specific api-types exist yet
  // Yard storage is in the logistics module
];
